import {lazy} from 'react';

const AppointmentsRescheduling = lazy(
  () => import('./AppointmentsRescheduling'),
);

export default AppointmentsRescheduling;
